import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'
import { bucket_url, retina_student_panel_url } from '../../constants/const'
import Loading from '../../components/layouts/Loading'
import Error404 from '../../components/Error/Error404'
import { useParams } from 'react-router-dom'
import { Container, Row, Col, Nav, Table, Tabs, Tab, Button } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";
import Collapsible from 'react-collapsible';
import CourseHeader from '../../components/courseHeader/courseHeader.component';
import PublicationCard from '../../components/publicationCard/publicationCard.component';
import PageTitle from '../../components/pageTitle/pageTitle.component';

import CoursesPageCover from '../../assets/images/banners/course-bg.jpg';
import CoverImage from '../../assets/images/publications/cover-1.png';

import './coursesDetailsPage.css';
import { LinkContainer } from 'react-router-bootstrap';

import DummyPdf from '../../assets/images/dummy/DummyMultiPdf.pdf';
import PdfModal from '../../components/pdfModal/pdfModal';


const CourseDetailsPage = props => {
    let count = 0;

    const { courseId } = useParams()

    const { loading, publications, courseModule } = useSelector(state => state.all)

    const [course, setCourse] = useState()

    const [visibleReader, setVisibleReader] = useState(false)
    const [selectedPDF, setSelectedPDF] = useState(null)
    const [selectedPublication, setSelectedPublication] = useState(null)

    const closeReader = () => {
        setSelectedPDF(null);
        setSelectedPublication(null);
        setVisibleReader(false);
    }

    const openReader = (pdf) => {
        setSelectedPDF(pdf);
        setVisibleReader(true);
    }

    useEffect(() => {
        setCourse(courseModule.find(item => item._id === courseId))
    }, [courseModule, courseId])

    useEffect(() => {
        if (course) {
            if (course.overview) {
                document.getElementById('course-overview').innerHTML = course.overview
            }
            course.modules.map((item, index) => {
                document.getElementById(`description${index}`).innerHTML = item.description
            })
        }
    }, [course])

    return (
        loading ? <Loading /> : course ?
            <>
                {(!!visibleReader && !!selectedPDF) && <PdfModal publication={selectedPublication} pdf={selectedPDF} visible={visibleReader} closeModal={closeReader.bind(this)} />}
                <CourseHeader
                    title={course.title}
                    cover={`${bucket_url}${course.coverPhoto}`}
                    price={course.price}
                    discount={course.discount}
                    description={course.description}
                    session={course.session}
                    id={course._id}
                />
                {/* <p>
                        {course.description}
                    </p> */}
                {/* <div className="description">
                        <ul>
                            <li>মোট লেকচার – ৩৬টি</li>
                            <li>সর্বমোট পরীক্ষা – ১২২টি</li>
                            <li>২৬৬টি মানসম্মত প্রশ্নপত্র</li>
                            <li>১৯,০০০ এরও বেশি প্রশ্ন সল্ভ</li>
                        </ul>
                    </div> */}
                {/* </CourseHeader> */}


                <section className="">
                    <Container fluid>
                        <Row>
                            <Col xs={12} lg={12} className="px-0">
                                <Tabs
                                    defaultActiveKey="course-overview"
                                    id="course-iformation-tab"
                                    className="course-iformation-tab course-nav-section justify-content-center border-bottom-0 pb-0"
                                >
                                    <Tab eventKey="course-overview" title="Overview">
                                        <section id="overview" className="py-5">
                                            <Container>
                                                <Row>
                                                    <Col xs={12}>
                                                        <div id='course-overview'>

                                                        </div>
                                                    </Col>
                                                    <Col xs={12}>
                                                        <div className="course-details-bottom-btns mt-4">
                                                            {
                                                                course?.pdfUrl &&
                                                                <Button target={'_blank'} href={`${bucket_url}${course.pdfUrl}`} className='file-download-btn mb-3' size='lg' download block><FaDownload /> রুটিন ডাউনলোড করুণ </Button>
                                                            }
                                                            <a style={{ textDecoration: 'none' }} target="_blank" rel='noreferrer' href={`${retina_student_panel_url}/sign-up?courseModuleId=${course._id}&title=${course.title}&description=${course.description}&price=${course.price}&discount=${course.discount}&coverPhoto=${course.cover}&session=${course.session}&enroll=${true}`}>
                                                                <Button className='enroll-btn' size='lg' block>Enroll Now</Button>
                                                            </a>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </section>
                                    </Tab>
                                    {
                                        (course && course.modules.length > 0) &&
                                        <Tab eventKey="course-module" title="Modules">
                                            <section id="course-module" className="course-module-section pt-5">
                                                <Container>
                                                    <Row className="mb-5">
                                                        <Col xs={12}>
                                                            {course.modules.map((item, index) => (

                                                                <Collapsible trigger={`${index + 1}. ${item.title}`}>
                                                                    <div id={`description${index}`}>
                                                                        {/* {item.description} */}
                                                                    </div>
                                                                </Collapsible>
                                                            ))}
                                                        </Col>
                                                    </Row>

                                                </Container>
                                            </section>
                                            {
                                                course?.pdfUrl &&
                                                <Container>
                                                    <Row>
                                                        <Col xs={12}>
                                                            <div className="course-details-bottom-btns mt-4">
                                                                <Button target="_blank" href={`${bucket_url}${course.pdfUrl}`} className='file-download-btn mb-3' size='lg' download block><FaDownload /> রুটিন ডাউনলোড করুণ </Button>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            }
                                        </Tab>
                                    }
                                    {
                                        (course && course.publications?.length > 0) &&
                                        <Tab eventKey="related-publications" title="Related Publications">
                                            <section id='related-publications' className="related-publication-section pt-5 pb-0 pb-md-5">
                                                <Container>
                                                    <Row>
                                                        {course.publications.map((item, index) => (
                                                            <Col xs={12} md={4} lg={3} className="mb-5">
                                                                <div className="related-publication-card-wrap d-flex flex-column align-items-center h-100">
                                                                    <PublicationCard item={item} hide={true} disable={true} />
                                                                    <div className="px-3 mt-3 w-100">
                                                                        <Button className='publication-read-more text-center' variant="outline-danger"
                                                                            onClick={() => {
                                                                                setSelectedPublication(item)
                                                                                openReader(item.pdfUrl);
                                                                            }}
                                                                        >পড়ে দেখুন</Button>
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Container>
                                            </section>
                                        </Tab>
                                    }
                                </Tabs>
                            </Col>
                        </Row>
                    </Container>
                </section>
                {/* <section className="course-nav-section pb-0">
                    <Container>
                        <Row>
                            <Col xs={12} lg={12}>
                                <Nav className="courses-nav justify-content-center" defaultActiveKey="#overview" as="ul">
                                    <Nav.Item as="li">
                                        <Nav.Link href="#overview">Overview</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link href="#course-module">Course Module</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item as="li">
                                        <Nav.Link href="#related-publications">Related Publications</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                        </Row>
                    </Container>
                </section> */}


                {/* {
                    course && course.faqs.length > 0 &&
                    <section id="faq-section" className="faq-section pb-2">
                        <Container>
                            <Row className="mb-3">
                                <Col xs={12}>
                                    <h3 className="faq-sec-title text-center">বহুল জিজ্ঞাসিত প্রশ্নসমূহ</h3>
                                </Col>
                            </Row>
                            <Row className="mb-5">
                                <Col>
                                    {course.faqs.map((item, index) => (

                                        <Collapsible trigger={`${index + 1}.${item.question}`}>
                                            <p>
                                                {item.answer}
                                            </p>
                                        </Collapsible>
                                    ))}
                                </Col>
                            </Row>

                        </Container>
                    </section>
                } */}
            </> : <Error404 />
    )
}

export default CourseDetailsPage;